import { Component, OnInit } from '@angular/core';
import { ContactsTableComponent } from '../contacts-table/contacts-table.component';
import { ContactTableFilterComponent } from '../contact-table-filter/contact-table-filter.component';

@Component({
    selector: 'app-contacts-page',
    templateUrl: './contacts-page.component.html',
    styleUrls: ['./contacts-page.component.scss'],
    imports: [ContactTableFilterComponent, ContactsTableComponent]
})
export class ContactsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
